import { Component, OnInit, PLATFORM_ID, Inject, AfterViewInit, Renderer2 } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { isPlatformBrowser, DOCUMENT, isPlatformServer } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
//import * as AOS from 'aos';
import { LinkService } from '../../_services/langhfre.service';

//declare function ire(string,{}): any;

@Component({
  selector: 'app-academic-phrasebank',
  templateUrl: './academic-phrasebank.component.html',
  styleUrls: ['./academic-phrasebank.component.scss']
})
export class AcademicPhrasebankComponent implements OnInit {
  phaseBankSearchForm: FormGroup;
  email: any;
  // emailEnterprise : FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private LinkService: LinkService
  ) {
    this.phaseBankSearchForm = this.fb.group({
      'sentence': ['', Validators.required]
    });
  }

  ngOnInit() {
    this.titleService.setTitle("AI英文校正Trinka - アカデミックフレーズバンク");
    this.metaTagService.updateTag({ name: 'description', content: "無料で使えるAI英文校正Trinkaのアカデミックフレーズバンクは学術英語を書く際のリソース。学術的なライティングで使われるフレーズ・言い回しの代替案を見つけて、同じセンテンスの重複を避けることができます。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "AI英文校正Trinka - アカデミックフレーズバンク" });
    this.metaTagService.updateTag({ property: 'og:description', content: "無料で使えるAI英文校正Trinkaのアカデミックフレーズバンクは学術英語を書く際のリソース。学術的なライティングで使われるフレーズ・言い回しの代替案を見つけて、同じセンテンスの重複を避けることができます。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/academic-phrasebank' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/academic-phrasebank' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/academic-phrasebank' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/academic-phrasebank' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/academic-phrasebank' });
    if (isPlatformServer(this.platformId)) {
      let script = this._renderer2.createElement('script');
      script.type = `application/ld+json`;
      script.text = `
      {"name":"アカデミック・フレーズバンク","@type":"Product","brand":{"name":"トリンカ","@type":"Brand"},"gtin8":"","image":"https://www.trinka.ai/jp/assets/images/trinka_logo.svg","@context":"https://schema.org/","description":"無料で使えるAI英文校正Trinkaのアカデミックフレーズバンクは学術英語を書く際のリソース。学術的なライティングで使われるフレーズ・言い回しの代替案を見つけて、同じセンテンスの重複を避けることができます。","aggregateRating":{"@type":"AggregateRating","bestRating":"5","ratingCount":"25545","ratingValue":"4.5","worstRating":"1"}}
      `;
      this._renderer2.appendChild(this._document.head, script);

      let script1 = this._renderer2.createElement('script');
      script1.type = `application/ld+json`;
      script1.text = `
      {"@context":"https://schema.org/","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"AI英文校正ツールTrinka |学術英語に強いAIが英文添削","item":"https://www.trinka.ai/jp/"},{"@type":"ListItem","position":2,"name":"アカデミック・フレーズバンク","item":"https://www.trinka.ai/jp/academic-phrasebank"}]}
      `;
      this._renderer2.appendChild(this._document.head, script1);

      let script2 = this._renderer2.createElement('script');
      script2.type = `application/ld+json`;
      script2.text = `
      {"@context":"https://schema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"アカデミックフレーズバンクは、どのように役立ちますか？","acceptedAnswer":{"@type":"Answer","text":"学術論文の執筆は、文法的に正確な英語であるだけでなく、学術的な慣行に従った言い回しを使う必要があります。Trinkaのアカデミックフレーズバンクを使えば、ご自身で他の論文から最適なフレーズを探すのではなく、学術出版物で使われるフレーズが一覧表示されるため、効率的な執筆につながります。"}},{"@type":"Question","name":"アカデミックフレーズバンクのフレーズを使用することは、剽窃とみなされますか？","acceptedAnswer":{"@type":"Answer","text":"Trinkaのアカデミックフレーズバンクからフレーズを使用する際は、そのフレーズの骨格にご自身の研究成果などを落とし込むことで、オリジナルの文章にしてください。これにより、盗用・剽窃とみなされない英文執筆が可能になります。"}},{"@type":"Question","name":"Trinkaのアカデミックフレーズバンクは有料ですか？","acceptedAnswer":{"@type":"Answer","text":"Trinkaのアカデミックフレーズバンクは、無料でご利用いただけます。制限はありません。"}},{"@type":"Question","name":"Trinkaのアカデミックフレーズバンクは、どの分野で使用できますか？","acceptedAnswer":{"@type":"Answer","text":"Trinkaのアカデミックフレーズバンクには、あらゆる学術領域の膨大な数の論文・刊行物のデータベースから抽出されたフレーズ・文例が収録されています。分野に関わらずご活用いただけます。"}}]}
      `;
      this._renderer2.appendChild(this._document.head, script2);

      let script3 = this._renderer2.createElement('script');
      script3.type = `application/ld+json`;
      script3.text = `
      {"@context":"https://schema.org","@type":"SoftwareApplication","name":"Trinka 学術英語フレーズバンク","alternateName":"Academic Phrasebank by Trinka","url":"https://www.trinka.ai/jp/academic-phrasebank","inLanguage":"ja","operatingSystem":"Web","applicationCategory":"EducationalApplication","applicationSubCategory":"学術英語・研究英語の表現集","isAccessibleForFree":true,"description":"Trinkaの学術英語フレーズバンクは、論文や研究発表に使える英語表現を目的別・セクション別に探せるWebアプリ機能です。分野横断で使える自然な表現と例文を収録しています。","featureList":["論文セクション別のフレーズ検索","目的別（導入・方法・結果・考察等）の例文","コピー＆活用しやすい簡潔な表現","日本語UIでのナビゲーション"],"provider":{"@type":"Organization","name":"Trinka","url":"https://www.trinka.ai/jp/"},"sameAs":["https://www.trinka.ai/jp/"],"potentialAction":{"@type":"SearchAction","target":"https://www.trinka.ai/jp/academic-phrasebank?q={query}","query-input":"required name=query"}}
      `;
      this._renderer2.appendChild(this._document.head, script3);

      let script4 = this._renderer2.createElement('script');
      script4.type = `application/ld+json`;
      script4.text = `
      {"@context":"https://schema.org","@type":"WebPage","name":"AI英文校正Trinka - アカデミックフレーズバンク","url":"https://www.trinka.ai/jp/academic-phrasebank","description":"無料で使えるAI英文校正Trinkaのアカデミックフレーズバンクは学術英語を書く際のリソース。学術的なライティングで使われるフレーズ・言い回しの代替案を見つけて、同じセンテンスの重複を避けることができます。","image":"https://www.trinka.ai/jp/assets/images/trinka_logo.svg"}
      `;
      this._renderer2.appendChild(this._document.head, script4);

      //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
    }
  }

  sectionValue(section: string) {
    this.formSection = true;
    this.thankSection = false;
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  phaseBankSearch() {
    if (this.phaseBankSearchForm.valid) {
      const data: NavigationExtras = {
        state: {
          sentence: Object.values(this.phaseBankSearchForm.value)
        }
      };
      this.router.navigate(['academic-phrasebank-browse', 'topic', 'subtopic'], data);
    } else {
      this.toastr.warning("Search field can not be empty");
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.scrollToActiveTab();
    }, 0);
    if (isPlatformBrowser(this.platformId)) {
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/5KsBh4PQUPI" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  scrollToActiveTab() {
    const currentUrl = this.router.url;
    let activeElement: HTMLElement | null = null;

    if (currentUrl.includes('academic-phrasebank')) {
      activeElement = document.querySelector('#tab-phrasebank');
    } else if (currentUrl.includes('ai-content-detector')) {
      activeElement = document.querySelector('#tab-ai-detector');
    } else if (currentUrl.includes('paraphrasing-tool')) {
      activeElement = document.querySelector('#tab-paraphraser');
    } else if (currentUrl.includes('grammar-checker')) {
      activeElement = document.querySelector('#tab-grammar');
    }

    // Ensure the active tab is scrolled into view
    if (activeElement) {
      activeElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    }
  }
}
